const SearchFilterFunction = (text, items, items2, noData) => {
  // sanitize the text and trim spaces
  let cleanText = text.toString().replace(/[�"*�%()\[\]{}=\\?�`'#<>|,;:+_]+/g, "").trim();
  let textLower = cleanText.toLowerCase();

  // if search text is empty, return all items
  if (!textLower) {
    return { items: items2, noData: false };
  }

  // filter items
  let filteredName = items2.filter((item) => {
    return Object.keys(item).some((key) =>
      item[key] !== undefined && item[key] !== null
        ? item[key].toString().toLowerCase().includes(textLower)
        : false
    );
  });

  // check if filtered result is empty
  if (filteredName.length === 0) {
    return { items: [], noData: true };
  } else {
    return { items: filteredName, noData: false };
  }
};

export default SearchFilterFunction;